export default "__VITE_ASSET__Jyp0UtS9__"